import controller from './login-box-mc.controller';

export default {
  bindings: {
    onReset: '&'
  },
  controller,
  template: require('./login-box-mc.html')
};



// WEBPACK FOOTER //
// src/app/components/login-dialog/login-box-mc/login-box-mc.component.ts